import { Row, Col, Image } from 'antd';
import { config } from '../../../config';
import { useTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import { ResponsiveContainer, Typography } from '@sunday/component';
import styles from './home-highlight.module.scss';
import highlightData from './home-highlight.json';

const { ASSET_PREFIX } = config;
const HomePageAchievementNameSpace = ['component.home.highlight'];

export const HomeHighlight = () => {
const { t } = useTranslation(HomePageAchievementNameSpace);
  return (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
      <ResponsiveContainer className={styles.container}>
        <Row justify="center">
          <Col xl={24} xs={0} style={{ marginBottom: "80px" }}>
            <Typography.Display designLevel={3} weight='bold' >
              {t('title')}
            </Typography.Display>
            <Typography.Title designLevel={3} >
              {t('body')}
            </Typography.Title>
          </Col>
          <Col xl={0} xs={24}>
            <Typography.Headline designLevel={1} weight='bold' >
              {t('title')}
            </Typography.Headline>
            <Typography.Title designLevel={3} >
              {t('body')}
            </Typography.Title>
          </Col>
        </Row>
        <Row justify={"center"}>
          {highlightData.map((item: any, index: number) => (
            <Col key={`highlight-${index+1}`} style={{width: "400px", margin: index === 1 ? "0 80px" : "0 0 "}}>
              <Image
                preview={false}
                alt={item.altImg}
                src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                style={{ marginBottom: "40px" }}
              />
              <Typography.Headline designLevel={2} weight='bold' style={{ marginTop: 0 }}>
                {t(`highlights.item-${index+1}.title`)}
              </Typography.Headline>
              <Typography.Body designLevel={2} >
              {t(`highlights.item-${index+1}.body`)}
              </Typography.Body>
            </Col>
          ))}
        </Row>
      </ResponsiveContainer>
    </div>
  );
};

export default withTranslation('page.home')(HomeHighlight);
